// ProtectedRoute.jsx
import { useContext } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { Spinner } from "react-bootstrap";
import GlobalContext from "../context/GlobalContext";
import i18n from "../i18n";

const ProtectedRoute = () => {
  const location = useLocation();
  const { authChecked } = useContext(GlobalContext);

  // Tunggu pengecekan sesi SSO (cookie dari login di sewoork.com) sebelum memutuskan redirect.
  if (!authChecked) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ minHeight: "100vh" }}
      >
        <Spinner animation="border" variant="primary" />
      </div>
    );
  }

  const userProfile = localStorage.getItem("userProfile");

  if (!userProfile) {
    // Clean up any stale pending registration data when user is not logged in
    const pendingData = localStorage.getItem("pendingRegisterCompany");
    if (pendingData) {
      localStorage.removeItem("pendingRegisterCompany");
    }

    return (
      <Navigate
        to="/login"
        replace
        state={{
          from: location,
          message: i18n.t("session.login_first"),
        }}
      />
    );
  }

  let parsedProfile = null;

  try {
    parsedProfile = JSON.parse(userProfile);
  } catch (error) {
    localStorage.removeItem("userProfile");
    return <Navigate to="/login" replace />;
  }
  const hasConsoleAccess = parsedProfile?.console_access !== false;
  const isOnboardingPage = location.pathname === "/onboarding";
  const isRegisterPage = location.pathname === "/register";

  if (!hasConsoleAccess && !isOnboardingPage && !isRegisterPage) {
    return <Navigate to="/onboarding" replace />;
  }

  if (hasConsoleAccess && isOnboardingPage) {
    return <Navigate to="/dashboard" replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
